import * as React from 'react';
import { FC } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';
import app from 'src/js/App';
import { LangsMenuToggler } from './LangsMenuToggler';
import { LangsMenuList } from './LangsMenuList';

type PropsType = {
  submenu: boolean,
  setSubmenu: (value: boolean) => void;
};

const LangsMenu: FC<PropsType> = ({ submenu, setSubmenu }) => {
  const isDesktop = useMediaIsDesktop();
  if (isDesktop) {
    return (
      <Dropdown
        drop="left"
        className="dropdown dropdown-flat-list__item"
        show={submenu}
        onToggle={(isOpenLocal, event, metadata) => {
          if (metadata.source === 'rootClose') {
            setSubmenu(false);
          } else {
            setSubmenu(true);
          }
        }}
      >
        <Dropdown.Toggle variant="link" id="dropdown-langs-button">
          <LangsMenuToggler />
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdown-menu dropdown-flat-submenu"
        >
          <LangsMenuList />
        </Dropdown.Menu>
      </Dropdown>
    );
  }
  return (
    <div className="dropdown dropdown-flat-list__item">
      <button type="button" onClick={() => setSubmenu(true)}>
        <LangsMenuToggler />
      </button>
      {submenu ? (
        <ul className="dropdown-menu dropdown-flat-submenu show">
          <li>
            <button
              onClick={() => setSubmenu(false)}
              type="button"
              className="dropdown-flat-submenu__item dropdown-flat-submenu_toggle"
            >
              <i className="fal fa-angle-left" />
              {app.tForReact('catalog_channel_list', 'Language')}
            </button>
          </li>
          <LangsMenuList />
        </ul>
      ) : null}
    </div>
  );
};

export { LangsMenu };
